import React, { useState } from "react";
import { MenuOutlined } from "@ant-design/icons";
import LoggedInHeaderCategories from "../LoggedInHeaderCategories/LoggedInHeaderCategories";
import MobileMenu from "../MobileMenu/MobileMenu";
import logo from "../../Assets/bsWhite.png";
import { useNavigate } from "react-router-dom"
import "./HeaderTeacher.css";
import LoggedInTeacher from "../LoggedInUserInfo/LoggedInTeacher";

function HeaderTeacher({ setLoggedIn }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="header-teacher-container">
      <div className="header-section">
      <div className="header-logo-position">
        <div className="header-teacher-logo-position">
          <img src={logo} alt="bsWhite" className="header-logo-size" onClick={() => navigate("/")}/>
        </div>
          <div className="teacher-header-categories">
            <LoggedInHeaderCategories />
          </div>
        </div>
        <div className="user-container">
          <LoggedInTeacher setLoggedIn={setLoggedIn} />
        </div>
        <div className="burger-menu-icon" onClick={toggleMobileMenu}>
          <MenuOutlined />
        </div>
      </div>
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} isLoggedIn={true} />
    </div>
  );
}

export default HeaderTeacher;